class StbbiScreening {
    public HasGonorrhea: boolean;
    public HasChlamydia: boolean;
    public HasHBsAg: boolean;
    public HasSyphilis: boolean;
    public HasHiv: boolean;

    constructor(fields?: Partial<StbbiScreening>) {
        Object.assign(this, fields);
    }
}

export { StbbiScreening };
